import { getCookie } from "@solvari/utils";

import type { SessionType } from "@/service/service.ts";

import { createArgusEvent } from "@/client/createArgusEvent";
import { addInitEvent, initCookieConsentListener } from "@/events";
import {
  addMarketingParamsEventFromReferrer,
  addMarketingParamsEventFromUrl,
} from "@/events/marketingParams";
import { addCurrentPageEvent, addReferrerPageEvent } from "@/events/pageView";

function initRootClient(sessionType: SessionType) {
  if (sessionType === "new") {
    void addInitEvent();
    void addReferrerPageEvent();
  }

  if (sessionType === "cross-domain" || sessionType === "new") {
    const consentTypes = getCookie("solvariCookieConsent");
    if (consentTypes) {
      void createArgusEvent("cookie_consent", { consentTypes });
    }
  }
  initCookieConsentListener();

  const syncPromise = addCurrentPageEvent();
  if (
    document.referrer &&
    new URL(document.referrer).hostname === window.location.hostname
  ) {
    void addMarketingParamsEventFromReferrer();
  }
  void addMarketingParamsEventFromUrl();
  return syncPromise;
}

export { initRootClient };
